import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Input from "../inputField";
import { InfoArea } from "./styles";
import { StyledRow } from "./styles";
import { emailRE } from "../../common/regex";
import { PersonnelDropdown } from "components/personnelDropdown";
import { filterPersonnels } from "api/prequalify";
import { getEsubPersonnels } from "api/esub";
import { getECQSWizardContextSelector } from "data/selectors/ecqs";
import { formatPhoneNumber } from "common/formatPhoneNumber";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

export const Step2 = ({
  setDisable,
  addData,
  setAddData,
  isMobile,
  institution_id,
}) => {

  const wizardContext = useSelector(getECQSWizardContextSelector);
  const isESub = wizardContext === "e-sub";
  const personnelFilterApi = isESub ? getEsubPersonnels : filterPersonnels;

  const [phoneNumber, setPhoneNumber] = useState(isESub ? addData?.project_info?.owner_info?.owner_phone : addData?.owner_phone);
  const handlePhoneNumberChange = (value) => {
    isESub ? setAddData("project_info.owner_info.owner_phone", value) : setAddData("owner_phone", value);
  };

  return (
    <InfoArea
      isMobile={isMobile}
      marginTop="0px"
      marginLeft="8px"
      isColumn={true}
    >
      <StyledRow isMobile={isMobile}>
        {/* <Input
        id="inputWrap"
        label="Project Manager"
        type="text"
        placeholder=""
        labelSize="12px"
        fontSize="18px"
        value={addData?.manager || ''}
        setValue={(val) => setAddData('manager', val)}
        validateFunc={(item) => item.length > 0}
      /> */}

        <PersonnelDropdown
          className="inputWrap"
          value={isESub ? addData?.project_info.manager : addData?.manager}
          setData={setAddData}
          attribute={isESub ? "project_info.manager" : "manager"}
          filterApi={personnelFilterApi}
          label="Project Manager"
          noCheckIcon={true}
          noErrorBorder={true}
          institution_id={institution_id}
          isESub={isESub}
        />
        {/* <Input
        id="inputWrap"
        label="Project Superintendent"
        type="text"
        placeholder=""
        labelSize="12px"
        fontSize="18px"
        value={addData?.superintendent || ''}
        setValue={(val) => setAddData('superintendent', val)}
        validateFunc={(item) => item.length > 0}
      /> */}
        <PersonnelDropdown
          className="inputWrap"
          value={isESub ? addData?.project_info.superintendent : addData?.superintendent}
          setData={setAddData}
          attribute={isESub ? "project_info.superintendent" : "superintendent"}
          filterApi={personnelFilterApi}
          label="Project Superintendent"
          noCheckIcon={true}
          noErrorBorder={true}
          institution_id={institution_id}
        />
      </StyledRow>
      <StyledRow isMobile={isMobile}>
        <Input
          id="inputWrap"
          label="Project Owner"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={isESub ? addData?.project_info?.owner_info?.owner_name : addData?.owner || ""}
          setValue={(val) => isESub ? setAddData("project_info.owner_info.owner_name", val) : setAddData("owner", val)}
          validateFunc={(item) => item.length > 0}
          noCheckIcon={true}
          noErrorBorder={true}
        />
        <Input
          id="inputWrap"
          label="Owner Contact Person"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={isESub ? addData?.project_info?.owner_info?.owner_contact : addData?.owner_contact || ""}
          setValue={(val) => isESub ? setAddData("project_info.owner_info.owner_contact", val) : setAddData("owner_contact", val)}
          validateFunc={(item) => item.length > 0}
          noCheckIcon={true}
          noErrorBorder={true}
        />
      </StyledRow>
      <StyledRow isMobile={isMobile}>
        {/* <Input
          id="inputWrap"
          label="Phone Number*"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={formatPhoneNumber(addData?.owner_phone) || ''}
          setValue={(val) => setAddData('owner_phone', val)}
          validateFunc={(item) => item.length > 0}
          noCheckIcon={true}
          noErrorBorder={true}
        /> */}

        <div style={{ marginTop: "24px", width: "100%" }}>
          <label htmlFor="phone" style={{ fontSize: "12px" }}>
            Phone Number
          </label>
          <div style={{ height: "47px", width: "100%", marginTop: "-10px" }}>
            <PhoneInput
              id="phone"
              country={"ca"}
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              style={{ marginTop: "16px", width: "100%", height: "100%" }}
              inputStyle={{
                fontSize: "18px",
                padding: "8px",
                lineHeight: "24px",
                marginLeft: "20px",
                paddingLeft: "28px",
                height: "100%",
                width: "45%",
              }}
              dropdownStyle={{ fontSize: "18px", lineHeight: "24px" }}
            />
          </div>
        </div>

        <Input
          id="inputWrap"
          label="Email"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={isESub ? addData?.project_info?.owner_info?.owner_email : addData?.owner_email || ""}
          setValue={(val) => isESub ? setAddData("project_info.owner_info.owner_email", val) : setAddData("owner_email", val)}
          validateFunc={(item) => emailRE.test(item)}
          noCheckIcon={true}
          noErrorBorder={true}
          style={{ marginLeft: "-290px" }}
        />
      </StyledRow>
    </InfoArea>
  );
};
